export default {
  PCV: 'PCV',
  PLASMA: 'PLASMA',
  PLATELET: 'PLATELET'
}
